import SoftBox from "components/SoftBox";
import React, { useEffect, useRef, useState } from "react";
import { useAppServices } from "hook/services";
import toast from "react-hot-toast";
import "./accountDetailTabs.css";

const FIELD_LABELS = {
  privacy: "Privacy link",
  terms_condition: "Terms and Conditions link",
  community: "Community link",
  help_center: "Help Center link",
  video_tutorial: "Video tutorial link",
};

const LINK_FIELDS = Object.keys(FIELD_LABELS);

function Links({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [currentFormData, setcurrentFormData] = useState({
    privacy: "",
    terms_condition: "",
    community: "",
    help_center: "",
    video_tutorial: "",
  });
  const formDataRef = useRef(formData);

  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  useEffect(() => {
    if (formData) {
      setcurrentFormData(formData);
    }
  }, [formData]);

  const persistFields = async (fields, successMessage) => {
    const accountId = currentFormData?.id ?? formData?.id;
    if (!accountId) {
      toast.error("Business account not found");
      return false;
    }

    try {
      const payload = {
        _id: accountId,
        agency_id: formDataRef.current?.agency_id,
        ...fields,
      };
      const { response, error } = await AppService.accounts.update({ payload });
      if (error || response?.success === false) {
        toast.error(error?.message || response?.message || "Failed to save link");
        return false;
      }
      setcurrentFormData((prev) => ({ ...prev, ...fields }));
      await handleRefresh?.();
      toast.success(successMessage);
      return true;
    } catch (err) {
      console.error("Link save failed:", err);
      toast.error("Failed to save link");
      return false;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setcurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFieldBlur = (e) => {
    const { name, value } = e.target;
    if (!LINK_FIELDS.includes(name)) return;

    const savedValue = formDataRef.current?.[name] ?? "";
    if (String(value ?? "") === String(savedValue ?? "")) return;

    persistFields({ [name]: value }, `${FIELD_LABELS[name]} saved`);
  };

  return (
    <div className="sd-account-detail-tab">
      <div>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Privacy</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                onBlur={handleFieldBlur}
                placeholder="Privacy"
                name="privacy"
                value={currentFormData.privacy || ""}
              />
            </SoftBox>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Terms and Conditions</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                onBlur={handleFieldBlur}
                placeholder="Terms and Conditions"
                name="terms_condition"
                value={currentFormData.terms_condition || ""}
              />
            </SoftBox>
          </div>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Community</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                onBlur={handleFieldBlur}
                placeholder="Community"
                name="community"
                value={currentFormData.community || ""}
              />
            </SoftBox>

            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Help Center</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                onBlur={handleFieldBlur}
                placeholder="Help Center"
                name="help_center"
                value={currentFormData.help_center || ""}
              />
            </SoftBox>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Embed Video (Enter YouTube Link)</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                onBlur={handleFieldBlur}
                placeholder="Video Tutorial"
                name="video_tutorial"
                value={currentFormData.video_tutorial || ""}
              />
            </SoftBox>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Links;
